import { render, staticRenderFns } from "./UserEntry.vue?vue&type=template&id=23fbd129&"
import script from "./UserEntry.vue?vue&type=script&lang=js&"
export * from "./UserEntry.vue?vue&type=script&lang=js&"
import style0 from "./UserEntry.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports